import { SwitchProps } from '@material-ui/core';

export const switchComponent: SwitchProps = {
  color: 'primary',
};
